// Mirror of Shared/Calculators/FenceCalculator.cs.
import type { CalcDef, ResultLine } from "../types.js";
import * as F from "../format.js";

const fields: CalcDef["fields"] = [
  { key: "fenceLengthFt", kind: "number", default: 100, min: 1, max: 2000 },
  { key: "postSpacingFt", kind: "number", default: 8, min: 4, max: 10 },
  {
    key: "rails",
    kind: "select",
    defaultChoice: "3",
    choices: [
      { value: "2", set: { railsPerSection: 2 } },
      { value: "3", set: { railsPerSection: 3 } },
    ],
  },
  { key: "picketWidthIn", kind: "number", default: 5.5, min: 2, max: 12 },
  { key: "pricePerPost", kind: "number", default: 12, min: 0, max: 100 },
];

function compute(i: Record<string, number>): Record<string, number> {
  const length = F.get(i, "fenceLengthFt");
  const spacing = F.get(i, "postSpacingFt");
  const railsPer = F.get(i, "railsPerSection");
  const picketW = F.get(i, "picketWidthIn");
  const price = F.get(i, "pricePerPost");

  const sections = spacing > 0 ? F.ceilUnits(length / spacing) : 0;
  const posts = sections + 1;
  const rails = sections * railsPer;
  const pickets = picketW > 0 ? F.ceilUnits((length * 12) / picketW) : 0;
  const concreteBags = posts * 2;
  const cost = posts * price;

  return { sections, posts, rails, pickets, concreteBags, cost: F.round(cost, 2) };
}

function present(_i: Record<string, number>, r: Record<string, number>): ResultLine[] {
  const posts = F.get(r, "posts");
  return [
    { label: "Sections", value: F.intStr(F.get(r, "sections")) },
    { label: "Posts to buy", value: `${F.intStr(posts)} ${F.plural(posts, "post", "posts")}`, highlight: true },
    { label: "Rails", value: F.intStr(F.get(r, "rails")) },
    { label: "Pickets", value: F.intStr(F.get(r, "pickets")) },
    { label: "Concrete bags", value: F.intStr(F.get(r, "concreteBags")) },
    { label: "Est. post cost", value: F.usd(F.get(r, "cost")), sub: "rough — posts only, excludes rails, pickets, concrete & labor" },
  ];
}

export const fence: CalcDef = { slug: "fence-calculator", fields, compute, present };
